/* global axios */
import ApiClient from '../ApiClient';

class ConnectorsAPI extends ApiClient {
  constructor() {
    super('navi_connectors', { accountScoped: true });
  }

  // Get all connectors with types
  get() {
    return axios.get(this.url);
  }

  // Get a specific connector
  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  // Create a new connector
  create(data) {
    return axios.post(this.url, {
      navi_connector: data,
    });
  }

  // Update a connector
  update(id, data) {
    return axios.patch(`${this.url}/${id}`, {
      navi_connector: data,
    });
  }

  // Delete a connector
  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // Get connector types
  getConnectorTypes() {
    return axios.get(`${this.url}/connector_types`);
  }

  // Test connection
  testConnection(id) {
    return axios.post(`${this.url}/${id}/test_connection`);
  }

  verifyMarketplaceOrder(id, data) {
    return axios.post(`${this.url}/${id}/verify_marketplace_order`, data);
  }

  revokeMarketplaceOrder(id, data) {
    return axios.delete(`${this.url}/${id}/verify_marketplace_order`, { data });
  }

  registerSiengeWebhooks(id) {
    return axios.post(`${this.url}/${id}/register_sienge_webhooks`);
  }
}

export default new ConnectorsAPI();
